import { api, defineWebModule } from '@itc/sdk';
import { searchShipyards } from '../shared/endpoints.ts';

// Shipyards in the shell (design §7.5, plan 4C).
export default defineWebModule({
  name: 'shipyards',
  title: 'Shipyards',
  routes: [
    { path: '/shipyards', component: () => import('./pages/ShipyardsPage.vue'), meta: { permission: 'shipyards.view', title: 'Shipyards' } },
    { path: '/shipyards/:id', component: () => import('./pages/ProjectPage.vue'), meta: { permission: 'shipyards.view', title: 'Build' } },
  ],
  nav: [{ label: 'Shipyards', to: '/shipyards', permission: 'shipyards.view', icon: 'shipyards' }],
  admin: [{ label: 'Recipes', path: '/admin/shipyards', component: () => import('./admin/AdminPage.vue'), permission: 'shipyards.manage' }],
  search: { permissions: ['shipyards.view'], run: async (q, signal) => (await api(searchShipyards, { query: { q } }, { signal })).hits },
});
